const EXTERNAL_IP_INFO = 'EXTERNAL_IP_INFO';

export default {
    EXTERNAL_IP_INFO
};